import { getUserAvatar } from '../../../../utils/user'
import { getUserLabel } from '../../../User'

export function getEpostStatusTimelineRecipientItem(user) {
  return {
    avatar: getUserAvatar(user),
    label: getUserLabel(user),
  }
}
